<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">

      <div class="card">
        <div class="card-body">

          <card-section-header
            title="Schedules"
            icon="fas fa-list">
          </card-section-header>

          <div *ngIf="!siteOwners.length" style="text-align: center;">
            <p-progressSpinner></p-progressSpinner>
          </div>

          <ng-container *ngIf="siteOwners.length">
            <h6>Select a site owner</h6>
            <p-dropdown
              class="form-control"
              [(ngModel)]="selectedSiteOwner"
              [ngModelOptions]="{standalone: true}"
              [options]="siteOwners"
              placeholder="Select a site owner..."
              [style]="{'width':'100%'}"
              optionLabel="label"
              filter="true"
            ></p-dropdown>
            <br>
            <button type="submit" class="btn btn-success btn-round float-right" [disabled]="!selectedSiteOwner" (click)="onSubmit()">Go</button>
          </ng-container>
        </div>
      </div>

    </div>
  </div>
</div>
